import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hhg6www3ax: FaireBrandEntity = {
  token: "b_hhg6www3ax",
  type: "brand",
  name: "Luna Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/49f27e2d7b64d38a2da23d3354549efa95cb251be9d3c0333facef39932fbcb2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/161d99e0cbe9caac8a83cc0e4821d5448c378ff347fc727c8afa1060c8046321.png",
  logoUrl:
    "https://cdn.faire.com/fastly/49f27e2d7b64d38a2da23d3354549efa95cb251be9d3c0333facef39932fbcb2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/161d99e0cbe9caac8a83cc0e4821d5448c378ff347fc727c8afa1060c8046321.png",
  location: "Redlands, CA, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "Luna Naturals is an all-natural bug defense company - repelling bugs and keeping the environment and you safe",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:02.888Z",
    importedBy: "entity-db-cli",
  },
};
